import React, { useState } from 'react';
import { toast } from 'react-toastify';
import './Auth.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../Services/Services';
import { ClipLoader } from 'react-spinners';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailVerification = async (e) => {
    e.preventDefault();

    toast.dismiss();
    if (!isValidEmail(email)) {
      toast.error('Please enter a valid email address.', { autoClose: 3000 });
      return;
    }

    setLoading(true);
    try {
      toast.dismiss();
      const response = await axios.post(`${BASE_URL}/forgot-password`, null, { params: { email } });
      if (response?.status === 200) {
        toast.success("Email verified and OTP sent");
        navigate("/resetpassword");
      } else {
        toast.success(response?.data?.message);
      }

    } catch (error) {
      toast.dismiss();
      if (error?.response?.status === 503) {
        toast.error("Service Unavailable. Please try again later.", { autoClose: 3000 });
      } else {
        toast.error(error.response?.data?.message || 'Network error. Please check your connection and try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-container">
      <div className="login-form">
        <h2>Forgot Password</h2>
        <form onSubmit={handleEmailVerification}>
          <div className="password-input-container">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value.toLowerCase())}
              required
            />
          </div>
          <button type="submit" className='submit-button' disabled={loading}>
            {loading ? <ClipLoader color="#fff" loading={loading} size={30} /> : "Send OTP"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ForgotPassword;
